import Qualifications from "@/components/Qualifications";
import { motion } from "framer-motion";

export default function QualificationsPage() {
  return (
    <div data-testid="qualifications-page">
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-heading text-gg-red text-xs uppercase tracking-[0.3em]">Proof of Excellence</motion.span>
          <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="font-heading text-xl sm:text-2xl md:text-3xl font-extrabold uppercase tracking-tight mt-1">Qualifications & <span className="text-gg-red">Certifications</span></motion.h1>
        </div>
      </div>
      <Qualifications />
    </div>
  );
}
